<script>
export default {
  name: "ElTagColorGpsContractos",
  functional: true,
  props: {
    row: Object,
    column: String
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    const rowValue = context.props.row;
    let Contrato = "danger";
    if (rowValue.color) Contrato = rowValue.color;

    return createElement(
      "span",
      {
        class: `el-tag  el-tag--${Contrato} el-tag--plain`
      },
      val
    );
  }
};
</script>
